/*
 * Copyright (C) 2021 IHS Markit.
 * All Rights Reserved
 *
 * NOTICE: All information contained herein is, and remains
 * the property of IHS Markit and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to IHS Markit and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from IHS Markit.
 */

import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {ScreenerFilter} from '../modals/ScreenerFilter';
import {Family} from '../modals/Family';

@Injectable()
export class DataSharingService {

  public currentTab = '';
  public isinSource = new BehaviorSubject(String());
  public indexURL = new BehaviorSubject(String());
  public filteredBatchData = new ReplaySubject(1);
  public currentBatchData = new ReplaySubject(1);
  public  tabList = new BehaviorSubject(new Array<string>());
  // @ts-ignore
  public filters = new BehaviorSubject(new ScreenerFilter());
  public filterApplied = false;
  public currentPage = 0;
  public filteredObject: any;
  public headlineIndices: any;
  public holidays: any;
  public euriborValue: any;
  public EMIXIndices: any;
  public headlineIDs: any;
  public searchedData = [];
  public s3Contents = [];
  public currencyFilter: any;
  public fxVersionFilter: any;
  currentIsin = this.isinSource.asObservable();
  filteredBatch = this.filteredBatchData.asObservable();
  currentBatch = this.currentBatchData.asObservable();
  listOfTabs = this.tabList.asObservable();
  screenerFilters = this.filters.asObservable();
  filteredMap = new Map<string, any>();
  fetchedIndexFamily: Family[] = [];
  constructor() {
  }

  shareIndexDetails(message: string): void {
    this.isinSource.next(message);
  }

}
